webpackJsonp([226020273838829],{

/***/ 313:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(57);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _pricingModule = __webpack_require__(584);
	
	var _pricingModule2 = _interopRequireDefault(_pricingModule);
	
	var _variablesModule = __webpack_require__(587);
	
	var _variablesModule2 = _interopRequireDefault(_variablesModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PRICING_DETAILS = [{
	  title: "Developer",
	  key: "free",
	  price: "Free",
	
	  action_color: _variablesModule2.default.developerPrimaryColor,
	  primary_color: _variablesModule2.default.developerPrimaryColor,
	  card_color: _variablesModule2.default.whiteColor,
	
	  features: ["Upto 5K monthly tracked users", "1,000 geo fences", "Single app project", "Push notification engine"],
	  linktext: "Try Now",
	  link: "/signup"
	}, {
	  title: "Professional",
	  key: "professional",
	  price: "$300",
	  price_duration: "/month",
	  action_color: _variablesModule2.default.professionalPrimaryColor,
	  primary_color: _variablesModule2.default.professionalPrimaryColor,
	  card_color: _variablesModule2.default.whiteColor,
	
	  pricing_subtext: "Free 1 month trial",
	  features: ["Upto 20K monthly detected users", "5,000 geo fences", "Developer features", "Analytics dashboard"],
	  linktext: "Signup",
	  link: "/signup"
	}, {
	  title: "Enterprise",
	  key: "enterprise",
	  price: "$750",
	  price_duration: "/month",
	
	  action_color: _variablesModule2.default.enterprisePrimaryColor,
	  primary_color: _variablesModule2.default.enterprisePrimaryColor,
	  card_color: _variablesModule2.default.whiteColor,
	
	  pricing_subtext: "Free 1 month trial",
	  features: ["Upto 50K monthly detected users", "20,000 geo fences", "Professional features", "On-call support", "Multiple users"],
	  linktext: "Signup",
	  link: "/signup"
	}, {
	  title: "Premium",
	  key: "premium",
	  price: "Get a deal",
	  price_color: _variablesModule2.default.whiteColor,
	  action_color: _variablesModule2.default.premiumPrimaryColor,
	  primary_color: _variablesModule2.default.premiumGradientColor,
	  card_color: _variablesModule2.default.premiumGradientColor,
	  features: ["Greater than 1 lakh monthly detected users", "Unlimited geo fences", "Enterprise features", "Multiple app projects", "Analytics webhooks", "Data science & insights", "Dedicated account manager"],
	  linktext: "Contact us",
	  link: "/sales"
	}];
	
	var PricingBox = function PricingBox(p) {
	  return _react2.default.createElement(
	    "div",
	    { className: _pricingModule2.default.pricing__box__wrapper },
	    _react2.default.createElement(
	      "div",
	      {
	        className: _pricingModule2.default.pricing__title__card,
	        style: {
	          background: p.primaryColor
	        }
	      },
	      p.title
	    ),
	    _react2.default.createElement(
	      "div",
	      { className: _pricingModule2.default.pricing__box__panel },
	      _react2.default.createElement(
	        "div",
	        {
	          style: { background: p.cardColor },
	          className: _pricingModule2.default.pricing__box__price__action__wrapper
	        },
	        _react2.default.createElement(
	          "div",
	          { className: _pricingModule2.default.pricing__box__price__wrapper },
	          _react2.default.createElement(
	            "div",
	            {
	              style: { color: p.priceColor },
	              className: _pricingModule2.default.pricing__box__price
	            },
	            p.price,
	            _react2.default.createElement(
	              "span",
	              null,
	              p.priceDuration
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: _pricingModule2.default.pricing__box__price_subtext },
	            p.pricing_subtext
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          { className: _pricingModule2.default.pricing__box__action },
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            {
	              to: p.link,
	              style: { backgroundColor: p.buttonColor },
	              className: _pricingModule2.default.pricing__btn
	            },
	            _react2.default.createElement(
	              "span",
	              null,
	              p.linktext
	            )
	          )
	        )
	      ),
	      _react2.default.createElement(
	        "div",
	        { className: _pricingModule2.default.pricing__box__features },
	        _react2.default.createElement(
	          "ul",
	          null,
	          p.features.map(function (f, index) {
	            return _react2.default.createElement(
	              "li",
	              { key: index },
	              f
	            );
	          })
	        )
	      )
	    )
	  );
	};
	var PricingPage = function PricingPage() {
	  return _react2.default.createElement(
	    "div",
	    { className: _pricingModule2.default.pricing__page__panel },
	    PRICING_DETAILS.map(function (entry) {
	      return _react2.default.createElement(PricingBox, {
	        title: entry.title,
	        key: entry.key,
	        price: entry.price,
	        pricing_subtext: entry.pricing_subtext,
	        features: entry.features,
	        linktext: entry.linktext,
	        link: entry.link,
	        buttonColor: entry.action_color,
	        cardColor: entry.card_color,
	        primaryColor: entry.primary_color,
	        priceDuration: entry.price_duration,
	        priceColor: entry.price_color
	      });
	    })
	  );
	};
	
	exports.default = PricingPage;
	module.exports = exports["default"];

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box","pricing__page__panel":"src-pages----pricing-module---pricing__page__panel---2wbyt","pricing__box__wrapper":"src-pages----pricing-module---pricing__box__wrapper---3rZB4","pricing__title__card":"src-pages----pricing-module---pricing__title__card---286KE","pricing__box__panel":"src-pages----pricing-module---pricing__box__panel---1SFhU","pricing__box__price__action__wrapper":"src-pages----pricing-module---pricing__box__price__action__wrapper---1sJky","pricing__box__price__wrapper":"src-pages----pricing-module---pricing__box__price__wrapper---1IveA","pricing__box__price":"src-pages----pricing-module---pricing__box__price---1a3BM","pricing__box__price_subtext":"src-pages----pricing-module---pricing__box__price_subtext---25V-o","pricing__box__action":"src-pages----pricing-module---pricing__box__action---3SU-R","pricing__btn":"src-pages----pricing-module---pricing__btn---_Zy2w","pricing__box__features":"src-pages----pricing-module---pricing__box__features---3otBf"};

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"whiteColor":"#fff","developerPrimaryColor":"#589e69","professionalPrimaryColor":"#13B9E4","enterprisePrimaryColor":"#eca85a","premiumPrimaryColor":"#FFFFFF59","premiumGradientColor":"transparent linear-gradient(44deg, #5000B7 0%, #21024A 100%) 0% 0% no-repeat padding-box"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-pricing-js-156d310ecdb367a609be.js